export default __webpack_public_path__ + "5a56514e43939c0cbe26e42e25c832a2.svg";